import {
    Directive,
    Input,
    HostListener,
    HostBinding,
    OnDestroy
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { DlgResourceOrdersComponent } from './dlg-resource-orders/dlg-resource-orders.component';
import { ResourceOrdersDataSource } from './resource-orders/resource-orders.data-source';

import { ApiService } from '../core/upgraded-providers';

import { underShardResources } from './constants';

@Directive({
    selector: '[appShowResourceOrders]'
})
export class ShowResourceOrdersDirective implements OnDestroy{
    public resource;
    private _dataSource: ResourceOrdersDataSource;

    private _dialogRef: MatDialogRef<DlgResourceOrdersComponent>;

    @Input() data: any;

    _shard: string;
    @Input() set shard(shard: string) {
        this._shard = shard;
    }
    get shard(): string {
        if (underShardResources.includes(this.data._id)) {
            return null;
        }

        return this._shard;
    }

    @HostBinding('class.btn--striped') isLoading: boolean;

    @HostListener('click')
    onClick(): void {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;

        this.getData()
            .then((data) => {
                this.showDialog(data);
            })
            .then(() => {
                this.isLoading = false;
            });
    }

    constructor(
        private _dialog: MatDialog,
        private _apiService: ApiService
    ) {
        this._dataSource = new ResourceOrdersDataSource(this._apiService);
    }

    ngOnDestroy() {
        if (this._dialogRef) {
            this._dialogRef.close();
        }
    }

    getData(): Promise<[any, any, any]> {
        return this._dataSource.getData({
            shard: this.shard,
            resourceType: this.data._id
        });
    }

    showDialog(lists): void {
        this._dialogRef = this._dialog
            .open(DlgResourceOrdersComponent, {
                backdropClass: 'mat-backdrop--long-scroll',
                panelClass: ['mat-dialog--wide', 'mat-dialog--long-scroll', `dlg-resource--${ this.data.type }`],
                data: {
                    shard: this.shard,
                    resourceType: this.data._id,
                    ...lists
                }
            });

        this._dialogRef.afterClosed().subscribe(() => {
            this._dialogRef = null;
        });
    }
}
